import React from "react";
import UsersPanel from "@/components/UsersPanel";

export default function AdminUsers() {
  return <UsersPanel />;
}
